export enum ReportTemplateFieldType {
  Unknown,
  String,
  Byte,
  Short,
  Int,
  Long,
  Float,
  Double,
  Decimal,
  Boolean,
  Date,
  Image,
  Chart,
  MeasurementTable,
}
